import { Emitter } from './emitter';

/** iOS 13+ gates device motion behind an explicit, gesture-initiated grant. */
const requestPermission = (
  DeviceMotionEvent as unknown as {
    requestPermission?: () => Promise<PermissionState>;
  }
).requestPermission;

class Motion extends Emitter<number> {
  speed = 0;
  interval: number | null = null;

  onMotion = (event: DeviceMotionEvent) => {
    const { x, y, z } = event.acceleration ?? {};
    this.speed = Math.max(
      this.speed,
      Math.abs(x ?? 0),
      Math.abs(y ?? 0),
      Math.abs(z ?? 0),
    );
  };

  listen() {
    window.addEventListener('devicemotion', this.onMotion);
    this.interval = window.setInterval(() => {
      this.emit(Math.round(this.speed));
      this.speed = 0;
    }, 1000);
  }

  start() {
    if (typeof requestPermission === 'function') {
      requestPermission().then((state) => {
        if (state === 'granted') {
          this.listen();
        }
      });
    } else {
      this.listen();
    }
  }

  stop() {
    window.removeEventListener('devicemotion', this.onMotion);
    if (this.interval !== null) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.speed = 0;
  }
}

export default new Motion();
